// site logo

export default function WebbIcon() {

  return (
  <>
    <div className="py-1" >
      <i className='bx bx-globe text-color-main text-icon-md'></i>    
    </div>

  </>
  )
}